import * as React from "react";
import { useParams, useLocation } from "react-router-dom";
import PropertiesClient from "../../components/properties/PropertiesClient";
import { normalizeLocale } from "../../utils/locales";

type RouteParams = { locale?: string };

export default function PropertiesPage() {
  const { locale } = useParams<RouteParams>();
  const loc = normalizeLocale(locale);
  const location = useLocation();

  // Περνάμε το query string όπως είναι (?property_type=...&status=...)
  const initialSearch = location.search || "";

  return <PropertiesClient locale={loc} initialSearch={initialSearch} />;
}
